export const modalTitleHeight = '50px';
export const modalTopMargin = '75px';
export const modalHorPadding = '94px';
export const modalVerPadding = '24px';
